import { Icon, Tag } from '~/components';
import { Label } from '~/components/Label';

type AppliedFilterProps = {
  title: { id: string; label: string };
  value: { id: string; name: string };
  onRemove: (key: string, value: string) => void;
};

const AppliedFilter = ({ title, value, onRemove }: AppliedFilterProps) => {
  return (
    <Tag key={value.id} variant="secondary" size="sm" role="group">
      <Label disabled={true} asSpan>
        {title.label}:
      </Label>
      <Label asSpan>{value.name}</Label>
      <button
        onClick={() => onRemove(title.id, value.id)}
        aria-label={`Remove ${value.name} filter`}
      >
        <Icon
          type="circle-xmark"
          variant="regular"
          size="md"
          className="pl-xs"
        />
      </button>
    </Tag>
  );
};

AppliedFilter.displayName = 'AppliedFilter';
export { AppliedFilter };
